import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { faFileSlash } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import {
  Button,
  ButtonVariation
} from '~/components/Global/Interactions/Button'
import { useConfig } from '~/domains/configuration/queries/config'
import { themeClass } from '~/styles/theme.css'
import type { AttachmentType } from '../../types'
import {
  attachmentsGeneratingSubtitle,
  attachmentsGeneratingTitle,
  noAttachments,
  noAttachmentsIcon
} from '../AttachmentsViewer.css'

export const UnsupportedViewer = ({
  attachment
}: {
  attachment: AttachmentType
}) => {
  const { data: legacyUrl } = useConfig('organization.legacy_url')
  const downloadUrl =
    attachment.url?.indexOf('/admin') !== -1
      ? `${legacyUrl}${attachment.url}`
      : attachment.url

  return (
    <div className={clsx(noAttachments, themeClass)}>
      <div className={noAttachmentsIcon}>
        <FontAwesomeIcon icon={faFileSlash} />
      </div>
      <div className={attachmentsGeneratingTitle}>
        Format de fichier non supporté
      </div>
      <div className={attachmentsGeneratingSubtitle}>
        Ce type de fichier ne peut pas être affiché directement.
        {attachment.url && (
          <>
            <br />
            Vous pouvez le télécharger pour l'ouvrir avec une application
            appropriée.
          </>
        )}
      </div>
      {attachment.url && (
        <Button
          variation={ButtonVariation.Primary}
          type="button"
          onClick={() => window.open(downloadUrl)}
        >
          <FontAwesomeIcon icon={faDownload} />
          Télécharger le fichier
        </Button>
      )}
    </div>
  )
}
